'use client'

import posthog from 'posthog-js'
import { PostHogProvider as PHProvider } from 'posthog-js/react'
import { useEffect } from 'react'

// Liste des emails des employés internes à filtrer
const INTERNAL_EMAILS: string[] = [
  'axel.pouppart31@gmail.com',
]

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    if (typeof window !== 'undefined' && !posthog.__loaded) {
      // Utiliser directement l'URL de PostHog (le reverse proxy /ingest ne fonctionne
      // pas de façon fiable sur Netlify : 400 Bad Request sur les requêtes gzip)
      const apiHost = process.env.NEXT_PUBLIC_POSTHOG_HOST || 'https://v.visualgrid.app';

      posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY!, {
        api_host: apiHost,
        ui_host: 'https://eu.posthog.com',
        capture_pageview: 'history_change',
        capture_pageleave: true,
        persistence: 'localStorage',
        autocapture: true, // Capture automatique des clics (peut être désactivé si trop bruit)
        disable_session_recording: false, // Activer session replay
        session_recording: {
          maskAllInputs: true, // Masquer les inputs sensibles
          maskTextSelector: '*[data-sensitive]', // Masquer les éléments avec data-sensitive
        },
        // Error Tracking automatique
        capture_clickevents: true,
        capture_performance: true,
        // Capture des erreurs JavaScript non gérées
        capture_exceptions: true,
        // Capture des console.error, console.warn
        capture_console_log: true,
        // Configuration avancée pour error tracking
        advanced_disable_toolbar_metrics: false,
        // Capture des erreurs de réseau
        capture_network_error: true,
        // Filtrage des utilisateurs internes
        before_send: (event) => {
          if (!event) return event
          const email = event.properties?.email || event.$set?.email
          if (email && INTERNAL_EMAILS.some(internalEmail => email.toLowerCase() === internalEmail.toLowerCase())) {
            return null // Bloquer l'événement
          }
          return event
        },
      })
    }
  }, [])

  return <PHProvider client={posthog}>{children}</PHProvider>
}
